import React, { useEffect, useState } from 'react';
import { useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';
import { LanguageContext } from '../contexts/LanguageContext';
import {
  ElementAttribute,
  ElementCard,
} from '../components/ElementCard/ElementCard';
import { Box } from '@mui/material';
import ElementCardGroup from '../components/ElementCard/ElementCardGroup';
import { globalBuilder } from '../../archbuilder/GlobalBuilder';

export const Works: React.FC = () => {
  const { theme, setThemes } = useContext(ThemeContext);
  const { t } = useContext(LanguageContext);

  let turnOfLeft = false;

  const getTurn = () => {
    turnOfLeft = !turnOfLeft;
    return turnOfLeft;
  };

  useEffect(() => {
    setThemes(['pages', 'elementcards', 'modaldialog']);
  }, []);

  const attributesList5: ElementAttribute[] = [
    {
      name: t('works/hyperbole/description/tag'),
      content: t('works/hyperbole/description/desc'),
    },
    {
      name: t('works/hyperbole/techs/tag'),
      content: t('works/hyperbole/techs/desc'),
    },
    {
      name: t('works/hyperbole/link/tag'),
      content: t('works/hyperbole/link/desc'),
      ref: t('works/hyperbole/link/ref'),
      href: t('works/hyperbole/link/href'),
    },
  ];
  
  const attributesList1: ElementAttribute[] = [
    {
      name: t('works/arcweave/description/tag'),
      content: t('works/arcweave/description/desc'),
    },
    {
      name: t('works/arcweave/techs/tag'),
      content: t('works/arcweave/techs/desc'),
    },
    {
      name: t('works/arcweave/link/tag'),
      content: t('works/arcweave/link/desc'),
      ref: t('works/arcweave/link/ref'),
      href: t('works/arcweave/link/href'),
    },
  ];

  const attributesList2: ElementAttribute[] = [
    {
      name: t('works/novelamk/description/tag'),
      content: t('works/novelamk/description/desc'),
    },
    {
      name: t('works/novelamk/link/tag'),
      content: t('works/novelamk/link/desc'),
      ref: t('works/novelamk/link/ref'),
      href: t('works/novelamk/link/href'),
    },
  ];
  const attributesList3: ElementAttribute[] = [
    {
      name: t('works/srpg/description/tag'),
      content: t('works/srpg/description/desc'),
    },
    {
      name: t('works/srpg/link/tag'),
      content: t('works/srpg/link/desc'),
      ref: t('works/srpg/link/ref'),
      href: t('works/srpg/link/href'),
    },
  ];

  const attributesList4: ElementAttribute[] = [
    {
      name: t('works/mkparty/description/tag'),
      content: t('works/mkparty/description/desc'),
    },
    {
      name: t('works/mkparty/techs/tag'),
      content: t('works/mkparty/techs/desc'),
    },
    {
      name: t('works/mkparty/link/tag'),
      content: t('works/mkparty/link/desc'),
      ref: t('works/mkparty/link/ref'),
      href: t('works/mkparty/link/href'),
    },
  ];

  return globalBuilder.Works(
    attributesList1,
    attributesList2,
    attributesList3,
    attributesList4,
    attributesList5,
    getTurn,
  );
};
